import { Cct, DocumentType } from "../../__generated__/graphql";
import { CctDetailsFieldFullValueFieldsFragment } from "../../__generated__/operations/graphql";
import React, { use, useMemo } from "react";
import { useUserLocaleTag, useI18n } from "../../hooks/i18n-hooks";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import ListGroup from "../ListGroup";
import ListItem from "../../ui_atoms/ListItem";
import { DocumentContext } from "../../contexts/DocumentManager";

type CctDetailsProps = {
    cct: Cct;
    cctDetails: CctDetailsFieldFullValueFieldsFragment;
    useLseCct?: boolean;
    navigation?: StackNavigationProp<RootStackParamList, "CctDetails">;
};

const CctDetails: React.FC<CctDetailsProps> = ({ cct, cctDetails, useLseCct }) => {
    const i18n = useI18n();
    const localeTag = useUserLocaleTag();
    const { showDocument } = use(DocumentContext);

    const cctUrl = useMemo(() => {
        if (useLseCct) {
            return `https://www.tempservice.ch/tools/pdf/detail.php?cid=${cct.cctContractId}&vid=${cct.cctVersionId}&eid=${cct.cctEditionId}&lang=${localeTag}`;
        } else if (cct.cctUrl) {
            return cct.cctUrl;
        } else {
            return "";
        }
    }, [cct, localeTag, useLseCct]);

    return (
        <>
            <ListItem
                title="CCT"
                description={cct?.name || ""}
                labels={cctUrl ? [{ text: i18n.t("see_more"), mode: "miniCta" }] : []}
                onPress={
                    cctUrl
                        ? () => {
                              showDocument({
                                  document: {
                                      id: "cct",
                                      title: "CCT",
                                      documentUrl: cctUrl,
                                      type: DocumentType.Other,
                                  },
                                  knownMimeType: "application/pdf",
                              });
                          }
                        : undefined
                }
            />
            <ListGroup
                items={cctDetails.readableValues
                    // Remove questions that have no answer (BAS-2787)
                    .filter((v) => v.answer.trim() !== "")
                    .map((v) => ({
                        title: v.question,
                        description: v.answer,
                        value: v.answer,
                    }))}
            />
        </>
    );
};

export default CctDetails;
